import styled, { css, RuleSet } from 'styled-components';

import { Size } from './types';
import { Colors, TextType } from '../types';

import { Text } from '../Text';
import { HTMLAttributes } from 'react';

const sizes: Record<Size, RuleSet> = {
  medium: css`
    padding: 20px;
    min-height: 64px;
  `,
  small: css`
    padding: 4px 16px;
    max-width: 180px;
    min-height: 50px;
  `,
};

const getSize = (size: Size) => {
  return sizes[size];
};

export const BtnText = styled(Text)<{ $textColor?: Colors }>`
  color: ${({ theme, $textColor }) => ($textColor ? theme[$textColor] : theme['on-primary'])};
`;

export const StyledButton = styled.button<
  {
    $backgroundColor?: Colors;
    $textColor?: Colors;
    $hoverColor?: Colors;
    $activeColor?: Colors;
    $textStyle?: TextType;
    $size?: Size;
    text?: string;
    disabled?: boolean;
    $isLoading?: boolean;
    $withPulsating?: boolean;
    $rightIcon?: string;
    $centerIcon?: string;
    $borderRadius?: Size;
    $mb?: number;
  } & HTMLAttributes<HTMLButtonElement>
>`
  position: relative;
  cursor: pointer;
  background-color: ${({ theme, $backgroundColor }) =>
    $backgroundColor ? theme[$backgroundColor] : theme['primary-default']};
  border-radius: ${({ $borderRadius, theme }) =>
    $borderRadius === 'small' ? `${theme['border-radius-small']}px` : `${theme['border-radius-medium']}px`};

  width: 100%;
  ${({ $size = 'medium' }) => getSize($size)};
  ${({ $mb }) => $mb && `margin-bottom: ${$mb}px`};
  word-break: break-word;

  &:hover:not(:disabled) {
    background-color: ${({ theme, $hoverColor }) => ($hoverColor ? theme[$hoverColor] : theme['primary-hovered'])};

    ${BtnText} {
      color: ${({ theme, $textColor }) => ($textColor ? theme[$textColor] : theme['on-primary'])};
    }
  }

  &:active:not(:disabled) {
    box-shadow: none;
    background-color: ${({ theme, $activeColor }) => ($activeColor ? theme[$activeColor] : theme['primary-active'])};
    animation: none;

    ${BtnText} {
      color: ${({ theme, $textColor }) => ($textColor ? theme[$textColor] : theme['on-primary'])};
    }
  }

  &:disabled {
    cursor: not-allowed;
    background-color: ${({ theme, $isLoading }) => ($isLoading ? theme['primary-active'] : theme['primary-disabled'])};
    animation: none;

    ${BtnText} {
      color: ${({ theme, $textColor }) => ($textColor ? theme[$textColor] : theme['on-primary'])};
    }
  }

  ${({ $withPulsating, $isLoading, $backgroundColor, theme }) =>
    $withPulsating &&
    !$isLoading &&
    `animation: pulsar 2s infinite; box-shadow: 0 0 0 0 ${
      $backgroundColor ? theme[$backgroundColor] : theme['primary-default']
    };`}

  ${({ $rightIcon }) => $rightIcon && 'padding-right: 42px; text-align: left;'};

  @keyframes pulsar {
    to {
      box-shadow: 0 0 0 14px transparent;
    }
  }
`;

export const CenteredLoaderBox = styled.div`
  display: flex;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const IconBox = styled.div<{ isCenter?: boolean }>`
  ${({ isCenter }) =>
    isCenter
      ? css`
          display: flex;
          justify-content: center;
          align-items: center;
          & img {
            height: 100%;
            margin-left: 6px;
          }
        `
      : css`
          & img {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 20px;
          }
        `};
`;
